<template>
  <v-dialog v-model="dialog.show" max-width="1000">
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-title>
        <v-btn
          outlined
          color="blue darken-2"
          rounded
          dark
          depressed
          small
          @click="$refs.dialogFormPrazo.show(false, {}, { ...financiamento })"
        >
          <v-icon left>mdi-plus-circle</v-icon>Novo Prazo
        </v-btn>
      </v-card-title>
      <DialogFormPrazo
        ref="dialogFormPrazo"
        @created="data.push($event)"
        @updated="updatePrazo($event)"
      />
      <v-card-text>
        <v-data-table :headers="headers" :items="data" :search="search">
          <template v-slot:top>
            <v-row dense>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  v-model="search"
                  label="Procurar..."
                  prepend-inner-icon="mdi-magnify"
                />
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.tabela>{{ financiamento.idBanco }}</template>
          <template v-slot:item.id="{ item }">{{ item.id | parcel }}</template>
          <template v-slot:item.coeficiente="{ item }">{{
            item.coeficiente | percent
          }}</template>
          <template v-slot:item.coeficienteSPF="{ item }">{{
            item.coeficienteSPF | percent
          }}</template>
          <template v-slot:item.taxaMes="{ item }">{{
            item.taxaMes | percent
          }}</template>
          <template v-slot:item.taxaAno="{ item }">{{
            item.taxaAno | percent
          }}</template>

          <template v-slot:item.ativo="{ item }">
            <v-btn color="transparent" small fab depressed>
              <v-icon :color="item.ativo ? 'green' : 'red'">{{
                item.ativo ? "mdi-check" : "mdi-close"
              }}</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.acoes="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="transparent"
                  small
                  fab
                  v-on="on"
                  depressed
                  @click="
                    $refs.dialogFormPrazo.show(
                      true,
                      { ...item },
                      { ...financiamento }
                    )
                  "
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              Editar Prazos
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Prazo from "@/services/prazo";

export default {
  name: "DialogTablePrazos",

  components: {
    DialogFormPrazo: () => import("./DialogFormPrazo")
  },

  data() {
    return {
      headers: [
        { text: "Tabela", value: "tabela", align: "start" },
        { text: "Prazo", value: "id", align: "start" },
        { text: "Coeficiente", value: "coeficiente", align: "start" },
        { text: "Coeficiente SPF", value: "coeficienteSPF", align: "start" },
        { text: "Taxa Mês", value: "taxaMes", align: "start" },
        { text: "Taxa Ano", value: "taxaAno", align: "start" },
        { text: "Ativo", value: "ativo", sortable: false, align: "center" },
        { text: "Ações", value: "acoes", sortable: false, align: "center" }
      ],
      data: [],
      search: "",
      dialog: {
        show: false,
        title: ""
      },
      servicePrazo: new Prazo(),
      financiamento: null
    };
  },

  methods: {
    async show(financiamento) {
      try {
        this.financiamento = financiamento;
        this.dialog.title = `Prazos do Financiamento ${financiamento.descricao}`;
        await this.getDataTable(financiamento);
        this.dialog.show = true;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getDataTable(financiamento) {
      try {
        const response = await this.servicePrazo.getByFinanciamento(
          financiamento
        );
        this.data = response;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    updatePrazo(prazoUpdated) {
      const index = this.data.findIndex(prazo => prazo.id === prazoUpdated.id);
      this.data[index].coeficiente = prazoUpdated.coeficiente;
      this.data[index].coeficienteSPF = prazoUpdated.coeficienteSPF;
      this.data[index].taxaMes = prazoUpdated.taxaMes;
      this.data[index].taxaAno = prazoUpdated.taxaAno;
      this.data[index].ativo = prazoUpdated.ativo;
    }
  }
};
</script>
